import MediaCatalog from "@/components/feature/MediaCatalog";
import { tvGenres } from "@/lib/media";

export default function TvShows() {
  return (
    <MediaCatalog
      kind="tv"
      breadcrumb="电视剧"
      title="电视剧分类"
      subtitle="TV Series Collection"
      intro="收录古装、都市、犯罪、科幻、家庭等热门电视剧集，卡片展示剧集数量与更新信息，支持按类型、地区、年份筛选与排序，轻松追剧不迷路。"
      genreOptions={tvGenres}
      meta={{
        title: "电视剧分类 - 免费观看大片在线观看",
        description:
          "免费观看大片在线观看电视剧分类页，汇聚古装、都市、犯罪、科幻、家庭等热门剧集资源，支持类型、地区、年份筛选与排序，方便查找与浏览。",
        keywords: "电视剧分类,热播电视剧,在线追剧,电视剧资源,影视大全,免费观看大片在线观看",
      }}
    />
  );
}